<template>
    <div>
        <v-snackbar top v-model="exists" color="red" class="pl-10">
            <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">{{ existMessage }}</span>
        </v-snackbar>
        <!-- customer added alert -->
        <v-snackbar top v-model="customerAddedMessage" color="green" class="pl-10">
            <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">The customer and the basebase have been created! Password Code has been copied to clipboard!</span>
        </v-snackbar>
        <!-- not allowed alert -->
        <v-snackbar top v-model="errorMessage" color="red" class="pl-10">
            <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">An error occured! Please stop and contact the support!</span>
        </v-snackbar>
        <!-- no valid domain alert -->
        <v-snackbar top v-model="noValidDomainMessage" color="red" class="pl-10">
            <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">please provide a valid domain (e.g. test.de)!</span>
        </v-snackbar>
        <form @submit.prevent="addCustomer" autocomplete="off">
            <v-select v-model="selectedlang" :items="stateItems" item-text="loc" item-value="id" label="Language" prepend-icon="mdi-map-marker" return-object color="primary"> </v-select>
            <v-text-field
                v-model="customerName"
                color="primary"
                label="Company..."
                prepend-icon="mdi-office-building-outline"
                @blur="
                    sanitizeCustomerName()
                    fillTextfields()
                "
                required
            />
            <v-text-field v-model="username" color="primary" label="Username..." prepend-icon="mdi-face" required />
            <v-text-field v-model="email" color="primary" label="Email..." type="email" prepend-icon="mdi-email" @blur="checkIfExists" required />
            <v-text-field v-model="password" color="primary" type="password" label="Password..." prepend-icon="mdi-lock-outline" />
            <v-text-field v-model="passwordCheck" color="primary" type="password" label="Confirm Password..." prepend-icon="mdi-refresh" required />
            <v-text-field
                v-model="domain"
                color="primary"
                label="Domains (e.g. searchinsights.de,quaro.io) - mehrere Domains nur mit Komma, OHNE Leertaste trennen wie vorgegeben"
                @blur="fillTextfields"
                prepend-icon="mdi-email"
            />

            <v-select :items="[true, false]" v-model="allow_user_cs" label="Allow Content Suite..." prepend-icon="mdi-account-group"></v-select>
            <v-select :items="[true, false]" v-model="allow_user_ms" label="Allow Monitoring Suite..." prepend-icon="mdi-account-group"></v-select>

            <v-select :items="plans" v-model="plan" item-text="text" item-value="value" return-object label="Plan..." prepend-icon="mdi-account-group"></v-select>
            <v-select :items="stati" v-model="status" item-text="text" item-value="value" return-object label="Status..." prepend-icon="mdi-account-group"></v-select>
            <v-select :items="campaigns" v-model="campaign" label="Campaign..." prepend-icon="mdi-account-group"></v-select>
            <v-select :items="mail_strecken" v-model="mail_strecke" item-text="text" item-value="value" return-object label="Mail Campaign..." prepend-icon="mdi-account-group"></v-select>

            <!-- <v-autocomplete :items="companies" v-model="company" item-text="name" item-value="company_id" return-object label="Company..." prepend-icon="mdi-office-building-outline"></v-autocomplete> -->
            <!-- <v-select :items="groups" v-model="group_id" item-text="text" item-value="value" return-object label="Group..." prepend-icon="mdi-account-group"></v-select> -->
            <v-text-field v-model="dbName" color="secondary" label="Database name..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="dbUsername" color="secondary" label="Database username..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="dockerName" color="secondary" label="Docker name..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="port" color="secondary" label="Port..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="credits" color="secondary" label="Credits..." prepend-icon="mdi-refresh" required />
            <v-checkbox v-model="send_password_mail" color="secondary" :label="'Send Password Mail: ' + send_password_mail" prepend-icon="mdi-refresh"></v-checkbox>
            <v-btn :disabled="btnDisabled" color="primary" outlined type="submit">
                Create Company &amp; Database
            </v-btn>
            <v-row v-if="latest_setpassword.user">Latest Password Link - User: {{ latest_setpassword.user }} | Link: {{ "https://app.quaro.io/setpassword" + latest_setpassword.code }}</v-row>
        </form>
    </div>
</template>
<script>
    export default {
        data: () => ({
            /**********************************************************
             * Create Company:
             **********************************************************/
            auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            customerName: "",
            domain: "",
            plan: "",
            credits: 150,
            plans: [
                { value: 0, text: "O - Research & Monitoring" },
                { value: 1, text: "1 - Research" }
            ],
            plan: { value: 1, text: "1 - Research" },
            stati: [
                { value: "testing", text: "1 - testing" },
                { value: "active", text: "2 - active" },
                { value: "paused", text: "3 - paused" },
                { value: "stopped", text: "4 - stopped" },
                { value: "inactive", text: "5 - inactive" }
            ],
            status: { value: "testing", text: "1 - testing" },
            dbName: "",
            dbUsername: "",
            dockerName: "",
            port: "",
            btnDisabled: false,
            errorMessage: false,
            customerAddedMessage: false,
            noValidDomainMessage: false,
            groups: [
                // { value: 1, text: "1 - Company Admin" },
                { value: 2, text: "2 - Read & Write" }
            ], //o = admin , 1 = user
            selectedlang: {
                id: 1,
                loc: "German",
                cc: "de"
            },
            stateItems: [
                {
                    id: 1,
                    loc: "German",
                    cc: "de"
                },
                {
                    id: 2,
                    loc: "English",
                    cc: "en"
                },
                {
                    id: 3,
                    loc: "Spanish",
                    cc: "es"
                }
            ],
            username: "",
            email: "",
            password: "",
            passwordCheck: "",
            companies: [],
            company: "",
            group_id: { value: 1, text: "1 - Company Admin" },
            campaign: "manual",
            campaigns: ["manual", "LinkedIn Malte", "LinkedIn Alex"],
            mail_strecken: [
                { value: "-", text: "Keine" },
                { value: "test_de", text: "14 Tage" },
                { value: "campixx", text: "30 Tage" },
                { value: "100", text: "100 Tage" }
            ],
            mail_strecke: { value: "test_de", text: "14 Tage" },
            exists: false,
            existMessage: "",
            send_password_mail: true,
            allow_user_cs: true,
            allow_user_ms: true,
            latest_setpassword: { user: "", code: "" }
        }),
        methods: {
            sanitizeCustomerName() {
                this.customerName = (this.customerName || "").replace(/[^a-zA-Z0-9äöüÄÖÜß ._\-&,/()']/gu, "")
            },
            checkIfExists: function() {
                let nameObject = {
                    user: this.email
                }
                this.$http.post(process.env.VUE_APP_APIURL + "/user/namecheck", nameObject, { headers: { Authorization: this.auth } }).then(function(response) {
                    if (response.body.register == false) {
                        this.existMessage = "That email already exists, please try something else"
                        this.exists = true
                        this.email = ""
                    }
                })
            },
            addCustomer() {
                let domains = this.domain.split(",")
                this.btnDisabled = true
                let dbObject = {
                    customerName: this.customerName,
                    domain: JSON.stringify(domains),
                    plan: this.plan.value,
                    status: this.status.value,
                    dbUsername: this.dbUsername,
                    dbName: this.dbName,
                    dockerName: this.dockerName,
                    port: this.port,
                    credits: this.credits,
                    campaign: this.campaign,
                    testing_duration: this.mail_strecke.value,
                    newsletter: 0,
                    testing_payment_duration: "",
                    username: this.username,
                    email: this.email.toLowerCase(),
                    password: this.password
                        ? this.password
                        : Math.random()
                              .toString(36)
                              .slice(-8),
                    lang: this.selectedlang.cc,
                    group: 2,
                    send_password_mail: this.send_password_mail,
                    user_cs: this.allow_user_cs,
                    user_ms: this.allow_user_ms
                }
                console.log(dbObject)
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/server/db/create/all", dbObject, { headers: { Authorization: this.auth } })
                    .then(async (response) => {
                        try {
                            await navigator.clipboard.writeText("https://app.quaro.io/setpassword" + response.body.code)
                        } catch (error) {
                            console.log(error)
                        }
                        try {
                            this.latest_setpassword.code = response.body.code
                            this.latest_setpassword.user = JSON.parse(JSON.stringify(this.customerName))
                        } catch (error) {
                            console.log(error)
                        }

                        console.log(response)
                        console.log(response.body.code)
                        this.customerName = ""
                        this.domain = ""
                        this.dbUsername = ""
                        this.dbName = ""
                        this.dockerName = ""
                        this.username = ""
                        this.password = ""
                        this.fetchPort()
                        this.btnDisabled = false
                        this.customerAddedMessage = true
                    })
                    .catch((error) => {
                        console.log(error)
                        this.btnDisabled = false
                        this.errorMessage = true
                    })
            },
            fetchPort() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/server/db/nextport", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.port = response.body
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fillTextfields() {
                let name = ""

                const regex = /^[a-zA-Z0-9][a-zA-Z0-9_.-]*$/
                let inputString = this.customerName

                // Ersetze unerwünschte Zeichen durch doppelte Anführungszeichen
                let cleanedString = inputString.replace(/[^a-zA-Z0-9_.-]/g, "")
                try {
                    if (this.domain.length > 0) {
                        let domainsplits = this.domain.split(".")
                        if (domainsplits.length > 1) {
                            name = domainsplits[0]
                        } else {
                            this.noValidDomainMessage = true
                            this.domain = ""
                            let value = cleanedString.toLowerCase()
                            value = value.replace(/ä/g, "ae")
                            value = value.replace(/ö/g, "oe")
                            value = value.replace(/ü/g, "ue")
                            value = value.replace(/ß/g, "ss")
                            value = value.replace(/ /g, "-")
                            value = value.replace(/\./g, "")
                            value = value.replace(/,/g, "")
                            value = value.replace(/\(/g, "")
                            value = value.replace(/\)/g, "")
                            name = value
                        }
                    } else {
                        let value = cleanedString.toLowerCase()
                        value = value.replace(/ä/g, "ae")
                        value = value.replace(/ö/g, "oe")
                        value = value.replace(/ü/g, "ue")
                        value = value.replace(/ß/g, "ss")
                        value = value.replace(/ /g, "-")
                        value = value.replace(/\./g, "")
                        value = value.replace(/,/g, "")
                        value = value.replace(/\(/g, "")
                        value = value.replace(/\)/g, "")
                        name = value
                    }
                } catch (error) {
                    this.noValidDomainMessage = true
                    this.domain = ""
                }
                this.dbName = name.replace(/-/g, "")
                this.dbName = name.replace(/&/g, "")
                this.dbUsername = "dbuser_" + name.replace(/-/g, "")
                this.dbUsername = this.dbUsername.replace(/&/g, "")
                let randomNumber = Math.floor(Math.random() * 101).toString()
                this.dockerName = "si-" + this.dbName + randomNumber + "-db"
                this.dockerName = this.dockerName.replace(/&/g, "")
            }
        },
        mounted() {
            this.fetchPort()
        }
    }
</script>
